import axios from "axios";
import i18n from "src/locales/i18n";
import { HOST_API } from "../config";
import { clearSession } from "./jwt";

const axiosInstance = axios.create({
  baseURL: HOST_API,
  headers: {
    "Content-Type": "multipart/form-data",
  },
});

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response.status === 401) {
      clearSession();
      return (window.location = "/auth/login");
    }
    return Promise.reject(
      (error.response && error.response.data) || "Something went wrong"
    );
  }
);

axiosInstance.interceptors.request.use(function (config) {
  const token = localStorage.getItem("accessToken");
  config.headers["Accept-Language"] = i18n.language;
  // config.params = { ...config.params, lang: i18n.language };

  if (token) {
    config.headers.Authorization = "Bearer " + token;
  }

  if (config.data instanceof FormData) {
    delete config.headers["Content-Type"];
  } else if (
    config.data &&
    typeof config.data === "object" &&
    !(config.data instanceof URLSearchParams)
  ) {
    config.headers["Content-Type"] = "application/json";
  } else if (!config.headers["Content-Type"]) {
    config.headers["Content-Type"] = "application/x-www-form-urlencoded";
  }

  return config;
});

export default axiosInstance;
